<div class="flxClmn bs-enabled">
	<div *ngIf="!isLoaded" class="centralize f-1-0 flxClmn">
		<loader height="100" width="100" style="opacity: 0.8;"></loader>
	</div>

	<div *ngIf="config" class="page-inner-content-holder gap-3 pt-0 flex-column animated fadeIn">
		<div *ngIf="!config.wa_enabled">
			<div style="text-align: center; margin: 0 auto; width:70%;">
				<i style="opacity:0.4;" class="zmdi zmdi-hc-4x"></i>
				<h1 style="opacity:0.4; font-size: 50px;">Archive is disabled</h1>
				<span>To activate the Archive feature, kindly reach out to our support team.</span>
				<br/>
				<hr/>
			</div>
		</div>

		<div *ngIf="config.wa_enabled">
			<div class="list-group list-group-flush settings-list-container">
				<div class="list-group-item settings-list-item py-5">
					<div class="title-section-container flex-column gap-2">
						<b>Enable Email Archive</b>
						<span class="lh-base" style="font-size: 0.9em;">Save all emails which go through your Email Relay (inbound and outbound) to an interactive archive. Archived emails can be searched, viewed, downloaded and more.</span>
					</div>
					<div class="content-container">
						<toggle-switch-c id="enableEmailArchiveToggle" *ngIf="config"
										 [(model)]="config.enabled"
										 (change)="updateArchiveConfigurations(dic.CONSTANTS.archiveActions.state)">
						</toggle-switch-c>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-5" *ngIf="journalEmailAddress && config?.enabled">
					<div class="title-section-container flex-column gap-2">
						<b>Journal Rule Settings (optional)</b>
						<span class="lh-base" style="font-size: 0.9em;">Configure the <a href="https://purview.microsoft.com/datalifecyclemanagement/exchange/journalrules" target="_blank" style="color: blue;">Journal Report email</a> settings if you want to archive your messages and some or all of your messages do not pass through an Email Relay/MX.</span>
					</div>
					<div class="content-container">
						<div class="flex-row align-items-center gap-3">
							<span class="fw-bold" style="flex-basis: 55px; font-size: 0.9em;">Email:</span>

							<input class="f-1-0 border-0 p-0" style="font-size: 12px; background: inherit;"
								   type="{{!showJournalAddress ? 'password' : 'text'}}"
								   [ngStyle]="{'letter-spacing' : showJournalAddress ? 'normal' : '2.4px'}"
								   [ngClass]="{'nofill': !showJournalAddress}"
								   [(ngModel)]="journalEmailAddress" disabled>

							<label class="hidepwd hvr-opacity" style="opacity: 0.4; margin-bottom: 0; font-size: 1.2rem; cursor: pointer;"
								   tooltip="{{showJournalAddress ? 'Hide' : 'Show'}}">
								<input type="checkbox" [(ngModel)]="showJournalAddress"/>
								<i class="fas fa-eye unchecked" ></i>
								<i class="fas fa-eye-slash checked"></i>
							</label>

							<a style="font-size: 1rem;"
							   (click)="copyJournalEmailToClipboard();"
							   tooltip="Copy">
								<i class="far fa-copy copy-link" style="cursor: pointer; color: #999999;"></i>
							</a>
						</div>
					</div>
				</div>

				<div class="list-group-item settings-list-item py-5" *ngIf="config?.enabled">
					<div class="title-section-container flex-column gap-2">
						<b>Archive Retention</b>
						<span class="lh-base" style="font-size: 0.9em;">Your archived emails will be permanently deleted after the selected amount of time.</span>
					</div>
					<div class="content-container flxRow gap-2" *ngIf="!editRetentionPeriod">
						<span>
							Retention period: <b>{{config.retention?.value}}</b>&nbsp;<b>{{config.retention?.period}}s</b>
						</span>
						<i class="far fa-edit link-primary" style="cursor: pointer;" tooltip="Edit" (click)="editRetention();"></i>
					</div>
					<div class="content-container flxRow gap-2 align-items-center" *ngIf="editRetentionPeriod">
						<span>Retention period:</span>
						<input required
							   [(ngModel)]="editRetentionPeriod.value"
							   type="number"
							   style="width: 75px;"
							   id="retention_value" name="retention_value"
							   size="5" placeholder="Number">
						<app-dropdown-c style="width: 90px;"
										text="{{editRetentionPeriod.period}}s">
							<li *ngFor="let item of dic.CONSTANTS.timePeriod | keyvalue: gs.returnZero"
								(click)="editRetentionPeriod.period = item.value;"
								id="{{item.value}}">
								{{item.value}}s
							</li>
						</app-dropdown-c>

						<btn-c style="min-width: 0;"
							   endIcon="zmdi zmdi-check"
							   [isDisabled]="editRetentionPeriod.inProcess"
							   (action)="editRetentionExecute()">
						</btn-c>
						<btn-c style="min-width: 0;"
							   endIcon="zmdi zmdi-close" color="danger"
							   variant="text"
							   btnTooltip="Cancel edit"
							   (action)="editRetentionPeriod = null;">
						</btn-c>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
